module.exports = __webpack_public_path__ + "img/halving_chart.a70bb84b.svg";